/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum ResearchProposalType {
	ByCompany = "ByCompany",
	ByProfessor = "ByProfessor",
}

export function ResearchProposalTypeFromJSON(json: any): ResearchProposalType {
	return ResearchProposalTypeFromJSONTyped(json, false);
}

export function ResearchProposalTypeFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ResearchProposalType {
	return json as ResearchProposalType;
}

export function ResearchProposalTypeToJSON(
	value?: ResearchProposalType | null
): any {
	return value as any;
}
